import { render } from "./CurrentNotifications.vue?vue&type=template&id=e225da0e&scoped=true&ts=true"
import script from "./CurrentNotifications.vue?vue&type=script&lang=ts"
export * from "./CurrentNotifications.vue?vue&type=script&lang=ts"

import "./CurrentNotifications.vue?vue&type=style&index=0&id=e225da0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e225da0e"]])

export default __exports__